<template>
  <div class="form-group">
    <div v-if="!file.id">
      <label for="attachments">Загрузите шаблон квитанции</label>
      <div class="drag-n-drop">
        <input type="file" id="attachments" class="form-control" name="file" @change="onFileChange">
        <i class="icon-upload"></i> перетащите файл сюда или кликните
      </div>
    </div>

    <ul class="files-list" v-if="file.id">
      <li>
        <div class="row">
          <div class="col-md-8">
            <a :href="file.file" target="_blank">{{ file.file }}</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { HTTP } from '@/http-common'

export default {
  name: 'attachments-field',
  props: {
    value: Object
  },
  data () {
    return {
      file: {
        id: '',
        file: ''
      }
    }
  },
  mounted () {
    this.file = this.value
  },
  watch: {
    file: function (val) {
      this.updateValue(val)
    },
    value: function (val) {
      this.file = val
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    onFileChange (e) {
      let data = new FormData()
      let files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        return
      }

      for (let key in files) {
        data.append('file', files[key], files[key].file)
      }

      HTTP.post('/bill-templates', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        this.file = response.data
        return true
      }).catch(err => {
        console.log(err.response)

        return false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Attachments.vue?6f6a224c